import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form-group row" };
const _hoisted_2 = { class: "col-sm-3 col-form-label" };
const _hoisted_3 = { class: "col-sm-9 col-form-label" };
const _hoisted_4 = { class: "form-group row" };
const _hoisted_5 = { class: "col-sm-3 col-form-label" };
const _hoisted_6 = { class: "col-sm-9 col-form-label" };
const _hoisted_7 = { class: "modal-footer" };
const _hoisted_8 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        ($setup.tenant)
            ? (_openBlock(), _createBlock($setup["BModal"], {
                key: 0,
                ref: "editTenant",
                "no-footer": "",
                centered: "",
                size: "lg",
                title: _ctx.$t('JTADM_TENANTS_EDIT_DETAILS')
            }, {
                default: _withCtx(() => [
                    _createVNode($setup["TenantForm"], {
                        tenant: $setup.tenant,
                        "onUpdate:tenant": _cache[0] || (_cache[0] = ($event) => (($setup.tenant) = $event)),
                        "onUpdate:invalid": _cache[1] || (_cache[1] = (value) => ($setup.invalid = value))
                    }, null, 8, ["tenant"]),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('JTADM_TENANT_CREATOR')), 1),
                        _createElementVNode("label", _hoisted_3, _toDisplayString($setup.tenant.creator_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('JTADM_TENANT_UPDATER')), 1),
                        _createElementVNode("label", _hoisted_6, _toDisplayString($setup.tenant.updater_name), 1)
                    ]),
                    _createElementVNode("footer", _hoisted_7, [
                        _createElementVNode("button", {
                            class: "btn btn-info text-white",
                            type: "submit",
                            disabled: $setup.invalid || !$setup.hasDifferences($setup.tenant, $setup.tenantOriginal, Object.keys($setup.tenantOriginal)),
                            onClick: _withModifiers($setup.editSubmit, ["prevent"])
                        }, _toDisplayString(_ctx.$t('JTADM_UPDATE')), 9, _hoisted_8),
                        _createElementVNode("button", {
                            class: "btn btn-danger",
                            type: "button",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => ($setup.editTenant?.hide()), ["prevent"]))
                        }, _toDisplayString(_ctx.$t('JTADM_CANCEL')), 1)
                    ])
                ]),
                _: 1
            }, 8, ["title"]))
            : _createCommentVNode("", true)
    ]));
}
